import { render, staticRenderFns } from "./SalesReportItemsDetails.vue?vue&type=template&id=ebbdbd72&"
import script from "./SalesReportItemsDetails.vue?vue&type=script&lang=ts&"
export * from "./SalesReportItemsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports